import { find, remove } from "lodash";

export default function AssessmentPayLoadMakerHelper(e, answers) {
  let question_id = parseInt(e.target.getAttribute("data-question-id"));
  let question_type = e.target.getAttribute("data-question-type");
  let exercise_id = parseInt(e.target.getAttribute("data-exercise-id"));
  let section_id = parseInt(e.target.getAttribute("data-section-id"));
  let page_id = parseInt(e.target.getAttribute("data-page-id"));
  let is_checkbox_checked =
    question_type === "CheckBox" ? e.target.checked : null;
  let is_radio_checked = question_type === "RadioBox" ? e.target.checked : null;
  let sel_answer = parseInt(e.target.value);
  if (question_type === "CheckBox" || question_type === "RadioBox") {
    PayloadMakerForCheckboxAndRadio(
      is_checkbox_checked,
      is_radio_checked,
      question_id,
      answers,
      sel_answer,
      exercise_id,
      section_id,
      page_id,
      question_type
    );
  } else if (question_type === "FillInBlank") {
    let question_number = parseInt(e.target.getAttribute("data-value"));
    let value = e.target.value;
    payloadMakerForFillInBlank(
      answers,
      value,
      question_id,
      exercise_id,
      section_id,
      page_id,
      question_number
    );
  } else if (question_type === "FillInBlankChoices") {
    let value = parseInt(
      e.target.selectedOptions[0].getAttribute("data-possible-question-id")
    );
    let question_number = parseInt(e.target.getAttribute("data-value"));
    PayloadMakerForFillInBlankChoices(
      answers,
      value,
      question_number,
      question_id,
      page_id,
      section_id,
      exercise_id
    );
  } else if (question_type === "writing") {
    let value = e.target.value;
    PayloadMakerForWriting(answers, value, page_id, section_id, exercise_id);
  }
}

function PayloadMakerForWriting(
  answers,
  value,
  page_id,
  section_id,
  exercise_id
) {
  let found_section = find(answers, ["section_id", section_id]);
  let found_page = find(answers, ["page_id", page_id]);
  let found_exercise = find(answers, ["exercise_id", exercise_id]);
  if (found_section && found_page && found_exercise) {
    found_exercise.answers = value;
  } else {
    answers.push({
      section_id: section_id,
      page_id: page_id,
      exercise_id: exercise_id,
      answers: value,
    });
  }
}

function PayloadMakerForFillInBlankChoices(
  answers,
  value,
  question_number,
  question_id,
  page_id,
  section_id,
  exercise_id
) {
  let not_found_in_array = true;
  if (answers.length === 0) {
    answers.push({
      section_id: section_id,
      page_id: page_id,
      exercise_id: exercise_id,
      answers: [
        {
          question_id,
          selected_answers: [{ number: question_number, id: value }],
        },
      ],
    });
  } else {
    answers &&
      answers.forEach((answer) => {
        if (
          answer.section_id === section_id &&
          answer.exercise_id === exercise_id &&
          answer.page_id === page_id
        ) {
          not_found_in_array = false;
          let found_answer = find(answer.answers, ["question_id", question_id]);
          if (found_answer) {
            let found_selected_answer = find(found_answer.selected_answers, [
              "number",
              question_number,
            ]);
            if (found_selected_answer) {
              found_selected_answer["id"] = value;
            } else {
              found_answer.selected_answers.push({
                number: question_number,
                id: value,
              });
            }
          } else {
            answer.answers.push({
              question_id,
              selected_answers: [{ number: question_number, id: value }],
            });
          }
        }
      });
    if (not_found_in_array) {
      answers.push({
        section_id: section_id,
        page_id: page_id,
        exercise_id: exercise_id,
        answers: [
          {
            question_id,
            selected_answers: [{ number: question_number, id: value }],
          },
        ],
      });
    }
  }
}

function payloadMakerForFillInBlank(
  answers,
  value,
  question_id,
  exercise_id,
  section_id,
  page_id,
  question_number
) {
  let not_found_in_array = true;
  if (answers.length === 0) {
    answers.push({
      section_id: section_id,
      page_id: page_id,
      exercise_id: exercise_id,
      answers: [
        {
          question_id,
          selected_answers: [{ number: question_number, answer: value }],
        },
      ],
    });
  } else {
    answers &&
      answers.forEach((answer) => {
        if (
          answer.section_id === section_id &&
          answer.exercise_id === exercise_id &&
          answer.page_id === page_id
        ) {
          not_found_in_array = false;
          let found_answer = find(answer.answers, ["question_id", question_id]);
          if (found_answer) {
            let found_selected_answer = find(found_answer.selected_answers, [
              "number",
              question_number,
            ]);
            if (found_selected_answer) {
              found_selected_answer["answer"] = value;
            } else {
              found_answer.selected_answers.push({
                number: question_number,
                answer: value,
              });
            }
          } else {
            answer.answers.push({
              question_id,
              selected_answers: [{ number: question_number, answer: value }],
            });
          }
        }
      });
    if (not_found_in_array) {
      answers.push({
        section_id: section_id,
        page_id: page_id,
        exercise_id: exercise_id,
        answers: [
          {
            question_id,
            selected_answers: [{ number: question_number, answer: value }],
          },
        ],
      });
    }
  }
}

function PayloadMakerForCheckboxAndRadio(
  is_checkbox_checked,
  is_radio_checked,
  question_id,
  answers,
  sel_answer,
  exercise_id,
  section_id,
  page_id
) {
  let not_found_in_array = true;
  if (answers.length === 0) {
    answers.push({
      section_id: section_id,
      page_id: page_id,
      exercise_id: exercise_id,
      answers: [{ question_id, selected_answers: [{ id: sel_answer }] }],
    });
  } else {
    answers &&
      answers.forEach((answer) => {
        if (
          answer.section_id === section_id &&
          answer.exercise_id === exercise_id &&
          answer.page_id === page_id
        ) {
          not_found_in_array = false;
          let found_answer = find(answer.answers, ["question_id", question_id]);
          if (found_answer) {
            let removed_selected_answer_arr = remove(
              found_answer.selected_answers,
              (sa_item_id) =>
                sa_item_id["id"] === sel_answer && is_checkbox_checked === false
            );

            if (
              found_answer.selected_answers.length === 0 &&
              is_checkbox_checked === false
            ) {
              let answer_index = answers.indexOf(found_answer);
              remove(
                answer.answers,
                (answer_item_id) =>
                  answer.answers.indexOf(answer_item_id) === answer_index &&
                  is_checkbox_checked === false
              );
            }
            if (
              removed_selected_answer_arr.length === 0 &&
              is_checkbox_checked
            ) {
              found_answer.selected_answers.push({ id: sel_answer });
            }
            if (is_radio_checked === true) {
              found_answer.selected_answers = [];
              found_answer.selected_answers.push({ id: sel_answer });
            }
          } else {
            answer.answers.push({
              question_id,
              selected_answers: [{ id: sel_answer }],
            });
          }
        }
      });

    if (not_found_in_array) {
      answers.push({
        section_id: section_id,
        page_id: page_id,
        exercise_id: exercise_id,
        answers: [{ question_id, selected_answers: [{ id: sel_answer }] }],
      });
    }
  }
}
